module.exports = __webpack_public_path__ + "img/uob.ff24dbbe.png";